var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "VueJsonToCsv",
    {
      attrs: {
        "json-data": _vm.list,
        separator: ";",
        "csv-title": `${_vm.csvName}_CSV`
      }
    },
    [
      _c(
        "BaseButtonComponent",
        { attrs: { block: "", variant: "primary-action" } },
        [_vm._v("\n    CSV\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }